import {OperableTarget} from './OperableTarget';
import {OperableAccount} from './OperableTarget/OperableAccount';
import {OperationAlias} from './OperationAlias';

export interface OperationModel extends OperationModel.Identity {
    type: OperationModel.Type;
    account: OperableAccount;
    target: OperableTarget;
}

export namespace OperationModel {
    export type Identity = {
        type: Type;
        account: OperableAccount.Identity;
        target: OperableTarget.Identity;
    };

    export type Type = 'exchange' | 'topup' | 'withdraw';

    export const isBuyOperation = (
        operation: OperationModel
    ): operation is OperationModel & {target: OperableAccount} => OperationAlias.from(operation) === 'buy';

    export const getMainAccount = (operation: OperationModel) => {
        if (isBuyOperation(operation)) {
            return operation.target;
        } else {
            return operation.account;
        }
    };
}
